import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProjectCard from "../components/ProjectCard";
import BlogCard from "../components/BlogCard";
import projects from "../data/projects";
import { getAllBlogs } from "../api/blogs";

const Home = () => {
  const [blogs, setBlogs] = useState([]);
  const [blogsLoading, setBlogsLoading] = useState(true);
  const [blogsError, setBlogsError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    getAllBlogs()
      .then((res) => {
        if (isMounted) setBlogs(res.data.slice(0, 3));
      })
      .catch(() => {
        if (isMounted) setBlogsError("Couldn't load the latest posts right now.");
      })
      .finally(() => {
        if (isMounted) setBlogsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      {/* ─────────────── HERO ─────────────── */}
      <section className="section" style={{ paddingTop: "5rem" }}>
        <div className="container" style={{ position: "relative" }}>
          <div
            className="dot-pattern"
            style={{
              position: "absolute",
              inset: 0,
              opacity: 0.15,
              pointerEvents: "none",
            }}
          />
          <div style={{ position: "relative", zIndex: 10, maxWidth: 720 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1.5rem" }}>
              <span
                className="pulse"
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "var(--emerald)",
                  display: "inline-block",
                }}
              />
              <span style={{ color: "var(--emerald)", fontSize: "0.875rem", fontWeight: 500 }}>
                Available for Work
              </span>
            </div>

            <h1 style={{ fontSize: "4rem", lineHeight: 1.1, marginBottom: "1rem", color: "var(--text-primary)" }}>
              Hi, I'm Srihari
            </h1>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, color: "var(--accent)", marginBottom: "1.5rem" }}>
              Full Stack Developer
            </h2>
            <p style={{ fontSize: "1.25rem", lineHeight: 1.6, color: "var(--text-muted)", marginBottom: "2rem" }}>
              I build fast, scalable web apps from frontend to backend.
            </p>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
              <Link to="/projects" className="btn btn-primary">
                View My Work →
              </Link>
              <Link to="/blogs" className="btn btn-outline">
                Read My Blog
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ─────────────── ABOUT TEASER ─────────────── */}
      <section className="section">
        <div className="container" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "3rem", alignItems: "center" }}>
          <div
            style={{
              width: 220,
              height: 220,
              borderRadius: "1rem",
              backgroundColor: "var(--bg-card)",
              border: "1px solid var(--border)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
            }}
          >
            <span style={{ fontSize: "3.5rem", fontWeight: 700, color: "var(--accent)" }}>KSR</span>
          </div>

          <div>
            <h2 className="section-title" style={{ marginBottom: "1.25rem" }}>
              About Me
            </h2>
            <p style={{ color: "var(--text-muted)", fontSize: "1.125rem", lineHeight: 1.8, marginBottom: "1.25rem" }}>
              I'm a passionate Full Stack Developer with 3+ years of experience building modern web
              applications, specializing in efficient, scalable solutions using cutting-edge technologies.
            </p>
            <Link to="/about" className="btn btn-outline">
              More About Me →
            </Link>
          </div>
        </div>
      </section>

      {/* ─────────────── PROJECTS PREVIEW ─────────────── */}
      <section className="section" style={{ backgroundColor: "var(--bg-primary)" }}>
        <div className="container">
          <h2 className="section-title">My Projects</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "1.5rem",
              marginBottom: "2.5rem",
            }}
          >
            {projects.slice(0, 3).map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
          <div style={{ textAlign: "center" }}>
            <Link to="/projects" className="btn btn-outline">
              View All Projects →
            </Link>
          </div>
        </div>
      </section>

      {/* ─────────────── BLOG PREVIEW ─────────────── */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Latest Blog Posts</h2>

          {blogsLoading && (
            <p style={{ color: "var(--text-muted)" }}>Loading latest posts…</p>
          )}

          {blogsError && (
            <p style={{ color: "var(--rose)" }}>{blogsError}</p>
          )}

          {!blogsLoading && !blogsError && blogs.length === 0 && (
            <p style={{ color: "var(--text-muted)" }}>No blog posts yet — check back soon.</p>
          )}

          {!blogsLoading && !blogsError && blogs.length > 0 && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "1.5rem",
                marginBottom: "2.5rem",
              }}
            >
              {blogs.map((blog, index) => (
                <BlogCard key={blog.id} blog={blog} index={index} />
              ))}
            </div>
          )}

          <div style={{ textAlign: "center" }}>
            <Link to="/blogs" className="btn btn-outline">
              View All Posts →
            </Link>
          </div>
        </div>
      </section>

      {/* ─────────────── CONTACT CTA ─────────────── */}
      <section className="section" style={{ backgroundColor: "var(--bg-secondary)", textAlign: "center" }}>
        <div className="container">
          <h2 className="section-title" style={{ marginBottom: "1.5rem" }}>
            Let's Build Something Great Together
          </h2>
          <Link to="/contact" className="btn btn-primary">
            Get In Touch
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
